import { useContext, useMemo } from 'react';
import { useUser } from '../providers/user.provider';
// import { UserContext } from '../providers/user.provider'; // adjust path

export const useProfileRole = () => {
    const user = useUser();
    const roleData = useMemo(() => {
        const currentProfile = user?.currentProfile;
        const delegatedData = currentProfile?.delegates?.find(
            (ar: { delegatedUserId: number | null; }) =>
                ar?.delegatedUserId === user?.user?.id
        );
        const accessRole = delegatedData?.accessRole;
        const isViewer = accessRole?.title === 'viewer';
        const canEdit = !isViewer;

        if (process.env.NODE_ENV !== 'production') {
            console.log("useProfileRole:State", canEdit);
        }

        return {
            isViewer,
            canEdit,
            accessRole
        };
    }, [user?.currentProfile, user?.user?.id]);

    return roleData;
};
// INFO How to use the hook
// import { ProtectedAction } from './components/ProtectedAction';
// import { useProfileRole } from './hooks/useProfileRole';
//
// function MyComponent() {
//     const { canEdit } = useProfileRole();
//
//     return (
//         <>
//             {/* Button protection */}
//         <ProtectedAction>
//         <button onClick={handleSave}>Save Changes</button>
//     </ProtectedAction>
//
//     {/* Input protection */}
//     <input
//         type="text"
//     disabled={!canEdit}
//     placeholder="Profile name"
//         />
//
//         {/* Conditional rendering */}
//     {canEdit && (
//         <button onClick={handleDelete}>Delete</button>
//     )}
//     </>
// );
// }
